module.exports = __webpack_public_path__ + "static/media/user-robot.76e8d6a8.svg";